export default "__VITE_ASSET__BOxWT6zP__"